import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import styled from 'styled-components';

import { AperturaStore, CapturaStore, UserStore } from '../../stores';

import { BreadcrumbProps } from 'antd/lib/breadcrumb/Breadcrumb';

import { PageHeader, Row, Select, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { CapturaHeaderDescription } from './CapturaHeaderDescription';

interface CapturaHeaderProps {
    aperturaStore?: AperturaStore;
    capturaStore?: CapturaStore;
    userStore?: UserStore;
}

const PageHeaderWrapper = styled.div`
    padding: 16px 32px 8px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
`;

const CenteredPageHeader = styled(PageHeader)`
    max-width: 1200px;
    margin: auto !important;
    padding: 0 !important;
    .ant-breadcrumb {
        margin-bottom: 16px !important;
    }
    .ant-page-header-title-view {
        width: 100% !important;
        text-align: center !important;
    }
    .ant-page-header-title-view-title {
        padding: 0 !important;
    }
`;

const Title = styled(Typography.Title)`
    font-size: 20px !important;
`;

const { Option } = Select;

@inject('aperturaStore')
@inject('capturaStore')
@inject('userStore')
@observer
export class CapturaHeader extends Component<CapturaHeaderProps> {
    renderMunicipioSelect = () => {
        const { capturaStore } = this.props;
        const { municipioOptions, selectedMunicipioId, setMunicipioId } = capturaStore!;

        return (
            <Select style={{ width: 200 }} value={selectedMunicipioId} onChange={setMunicipioId}>
                {municipioOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                        {option.title}
                    </Option>
                ))}
            </Select>
        );
    };

    renderRegistroKindSelect = () => {
        const { capturaStore } = this.props;
        const { registroKinds, selectedRegistroKind, setRegistroKind } = capturaStore!;

        return (
            <Select style={{ width: 200 }} value={selectedRegistroKind} onChange={setRegistroKind}>
                {registroKinds.map(kind => (
                    <Option key={kind} value={kind}>
                        {kind}
                    </Option>
                ))}
            </Select>
        );
    };

    renderContent = () => {
        const { aperturaStore, capturaStore } = this.props;
        const { apertura } = aperturaStore!;
        const { isLoading } = capturaStore!;

        return (
            <Row>
                <CapturaHeaderDescription span={8} term="Municipio" key="municipio">
                    {this.renderMunicipioSelect()}
                </CapturaHeaderDescription>
                <CapturaHeaderDescription span={8} term="Tipo" key="tipo">
                    {this.renderRegistroKindSelect()}
                </CapturaHeaderDescription>
                <CapturaHeaderDescription span={8} term="Apertura" key="apertura">
                    {isLoading ? 'Cargando...' : apertura}
                </CapturaHeaderDescription>
            </Row>
        );
    };

    render() {
        const { aperturaStore, capturaStore } = this.props;
        const { period } = aperturaStore!;
        const { isLoading } = capturaStore!;

        const breadcrumb: BreadcrumbProps = {
            itemRender: (route, _, routes, paths) => {
                const last = routes.indexOf(route) === routes.length - 1;
                return last ? (
                    <span>{route.breadcrumbName}</span>
                ) : (
                    <Link to={paths.join('/')}>{route.breadcrumbName}</Link>
                );
            },
            routes: [
                {
                    path: '/',
                    breadcrumbName: 'Home'
                },
                {
                    path: 'captura',
                    breadcrumbName: 'Recaudación'
                },
                {
                    path: 'captura',
                    breadcrumbName: 'Captura'
                }
            ]
        };

        return (
            <PageHeaderWrapper>
                <CenteredPageHeader
                    title={<Title>{isLoading ? 'Cargando...' : period}</Title>}
                    breadcrumb={breadcrumb}
                >
                    {this.renderContent()}
                </CenteredPageHeader>
            </PageHeaderWrapper>
        );
    }
}
